// src/components/Footer/Footer.tsx

import React from "react";
import styles from "./Footer.module.scss";
import { useTranslation } from "react-i18next";

const Footer: React.FC = () => {
  const { t } = useTranslation();

  const wechatId = "Unlimited-Advisory"; // 您的微信ID

  return (
    <footer className={styles.footer}>
      <div className={styles.contactInfo}>
        <p>{t("footer.address")}</p>
        <p>{t("footer.email")}</p>
      </div>
      <div className={styles.socialMedia}>
        {/* WeChat 以文本形式显示 */}
        <p>
          {t("footer.wechat")}: {wechatId}
        </p>

        <a href="https://www.unlimitedadvisoryllc.com/">
          {t("footer.website")}
        </a>
        <a href="https://unlimitedadvisory.taxdome.com/signup">
          {t("footer.taxdome")}
        </a>
      </div>
      <div className={styles.copyRight}>
        <p>{t("footer.copyright")}</p>
      </div>
    </footer>
  );
};

export default Footer;
